export default __webpack_public_path__ + "static/media/future.58aafd00.png";